/**
 * Employee roles that can action trip request approvals - Admin, Manager and Approver
 */
export const BUSINESS_TRAVELLER_APPROVER_ROLES: Array<App.BusinessTraveller.EmployeeRole> = [
  'BUSINESS_ADMIN',
  'BUSINESS_MANAGER',
  'BUSINESS_APPROVER',
]
